import { useState } from 'react'
import ModalProcessMultiSell from './ModalProcessMultiSell'
import { TwinDictionary } from '../../../../../utils/globals/dictionary'
import { ModalOpenedTy } from '../../../../../baseComponents/Modal/types'
import { ButtonPrimary } from '../../../../../baseComponents/Button'
import { ConflictsTyComplex, SetConflictsTyFncDispatch } from '../../../../../baseComponents/ModalsLayouts/ModalOrderIncompatibles/types'
import { TableData } from '../../../../../baseComponents/TwinTable/types'
import { OrderData } from '../../../../inputTableLayouts/order/OrderLayout/types'
import useEditDeleteModal from '../../../../../utils/hooks/useEditDeleteModal'
import ModalProcessMultiSellWithStock from './ModalProcessMultiSell/ModalProcessMultiSellWithStock'
import ModalSkipOperateStockOrder from '../../../../inputTableLayouts/order/OrderLayout/OrderTable/TableComponents/ModalsOrderTable/ModalSkipOperateStockOrder'
import ModalOrderPaymentMethod from '../../../../inputTableLayouts/order/OrderLayout/OrderTable/TableComponents/ModalsOrderTable/ModalOrderPaymentMethod'


interface MultiSellButtonProps {
    title: string
    children?: React.ReactNode
    data: OrderData
    getCompleteData: (inputtable?: TableData) => Promise<void>
    sellInfo: TwinDictionary
    conflicts: ConflictsTyComplex
    setConflicts: SetConflictsTyFncDispatch
    translateText: {
        titleText: string
        conflictText: string
        confirmText: string
    }
    urlProcess: string
    urlNavigate: string
}

const MultiSellButton: React.FC<MultiSellButtonProps> = ({ title, data, ...rest }) => {
    const [opened, setOpened] = useState<ModalOpenedTy>(null)
    return (
        <div className='items-center flex ml-auto'>
            <ButtonPrimary id={'sellMulti' + data?.header?.id} onClick={() => setOpened(true)}>{title}</ButtonPrimary>
            {opened ? <ModalProcessMultiSell setOpened={setOpened} data={data} {...rest} /> : null}
        </div>
    )
}

export const MultiSellButtonWithStock: React.FC<MultiSellButtonProps> = ({ title, data, ...rest }) => {
    const { openModal, setOpenModal } = useEditDeleteModal()
    return (
        <div className='items-center flex ml-auto'>
            <ButtonPrimary id={'sellMulti' + data?.header?.id} onClick={() => setOpenModal({ type: 'create', allRowData: { data } })}>{title}</ButtonPrimary>
            {openModal?.type === 'create' ? <ModalProcessMultiSellWithStock setOpenModal={setOpenModal} data={data} {...rest} /> : null}
            {openModal?.type === 'edit' ? <ModalSkipOperateStockOrder checkStockURLs={'/api/app/order/sell/sellOrder/checkAllSellMultiOrderProductsStock'} setOpenModal={setOpenModal} allRowData={{ ...openModal.allRowData, createUrl: rest.urlProcess, navigateUrl: rest.urlNavigate }} finalizeOrder={openModal.allRowData?.finalizeOrder} /> : null}
            {openModal?.type === 'delete' ? <ModalOrderPaymentMethod headerData={data.header} setOpened={() => setOpenModal(null)} allRowData={openModal.allRowData} totalsOrderTableData={openModal.allRowData?.totalsOrderTableData} beforeSubmit={openModal.allRowData.finalizeOrder} /> : null}
        </div>
    )
}

export default MultiSellButton